import React from 'react'
import Head from 'next/head'
import Pitch from '@src/components/DisposalPage/Pitch'
import FeatureList from '@src/components/DisposalPage/FeatureList'
import Approach from '@src/components/DisposalPage/Approach'
import FAQ from '@src/components/DisposalPage/FAQ'
import SustainabilityDashboardPromo from '@src/components/DisposalPage/SustainabilityDashboardPromo'
import SchemaMarkup from '@src/components/SchemaMarkup'
import RelatedServices from '@src/components/RelatedServices'
import Clients from '@src/pages/LandingPage/Clients'
import TrustBox from '@src/pages/common/components/TrustBox'
import TrustedByClients from '@src/components/DisposalPage/TrustedByClients'
import pageClasses from '@src/styles/sugary-beverage-disposal-page.module.css'
// eslint-disable-next-line import/extensions
import sugary from '../../json/sugary-beverage-disposal-data.json'

const sugaryServiceData = {
  name: 'Sugary Beverage Disposal and Recycling',
  description:
    'Sustainable sugary beverage disposal and recycling nationwide. Dimension removes expired sodas, juices, sports drinks, and energy drinks and reclaims their sugars as ethanol, with container recycling and full documentation.',
  serviceType: 'Sugary Beverage Disposal and Recycling',
  url: 'https://getdimension.com/sugary-beverage-disposal',
  provider: {
    name: 'Dimension',
    url: 'https://getdimension.com',
    address: {
      streetAddress: '2261 Market Street, #4061',
      addressLocality: 'San Francisco',
      addressRegion: 'CA',
      postalCode: '94114',
      addressCountry: 'US',
    },
    telephone: '+1 (415) 340-7182',
  },
  offers: [
    { name: 'Soda Disposal and Destruction' },
    { name: 'Juice and Sports Drink Disposal' },
    { name: 'Energy Drink Disposal' },
    { name: 'Recalled Beverage Destruction' },
    { name: 'Ethanol Reclamation' },
  ],
}

const sugaryFAQData = {
  questions: sugary.FAQContent.contentList.map((faq) => ({
    question: faq.heading.replace(/<[^>]*>/g, ''),
    answer: faq.textList.join(' '),
  })),
}

function SugaryBeverageDisposal() {
  return (
    <>
      <Head>
        <title>Sugary Beverage &amp; Soda Disposal Services | Dimension</title>
        <meta
          name="description"
          content="Sustainable sugary beverage disposal nationwide. Dimension removes expired soda, juice, and energy drinks and reclaims the sugars as ethanol, with container recycling. Cased pricing from ~$0.83/case."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://getdimension.com/sugary-beverage-disposal" />
        <SchemaMarkup type="WebSite" />
        <SchemaMarkup type="Service" data={sugaryServiceData} />
        <SchemaMarkup type="FAQPage" data={sugaryFAQData} />
        <SchemaMarkup type="LocalBusiness" />
      </Head>
      <div className={pageClasses.root}>
        <Pitch
          variant="hazardous-waste"
          heroImage="beverage"
          heading={sugary.pitch.heading}
          material={sugary.pitch.material}
          pitchText={sugary.pitch.pitchText}
          ctaLink={sugary.pitch.ctaLink}
          ctaText={sugary.pitch.ctaText}
          belowCta={<TrustBox isMobile isDark={false} />}
          belowPitch={<TrustedByClients />}
        />
        <Clients />
        <FeatureList {...sugary.solutions} />
        <SustainabilityDashboardPromo />
        <FeatureList {...sugary.benefits} />
        <Approach {...sugary.approach} />
        <FAQ {...sugary.FAQContent} />
        <RelatedServices
          services={[
            {
              label: 'Beverage Disposal Services',
              href: '/beverage-disposal',
              description:
                'Nationwide recycling of expired and surplus beverages of every kind through ethanol reclamation.',
            },
            {
              label: 'Alcoholic Beverage Disposal',
              href: '/alcoholic-beverage-disposal',
              description:
                'Compliant destruction and recycling of beer, wine, spirits, and other alcoholic beverages.',
            },
            {
              label: 'Milk and Dairy Disposal',
              href: '/milk-dairy-disposal',
              description:
                'Sustainable disposal of expired milk, yogurt, and dairy drinks with carton recycling.',
            },
            {
              label: 'Pallet Disposal',
              href: '/pallet-disposal',
              description:
                'Pickup and recycling of surplus and broken pallets for warehouses and distributors.',
            },
          ]}
        />
      </div>
    </>
  )
}

export default SugaryBeverageDisposal
